"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.V2NotificationSettings = void 0;
var react_1 = __importStar(require("react"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UseNotificationsSettings_1 = require("./UseNotificationsSettings");
var styles = __importStar(require("./V2Notifications.css"));
var NumberInput_1 = __importDefault(require("@CommonFrontend/NumberInput/NumberInput"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var UseIsFirstRender_1 = require("./UseIsFirstRender");
var selectOptions = [
    { label: "Every time", value: "every" },
    { label: "First time", value: "first" },
    { label: "Custom", value: "custom" },
];
var CustomNumberEndElement = function () { return (react_1.default.createElement(kaleidoscope_1.Text, { className: styles.inputUnitText, element: "div", secondary: true, size: "s" }, "times")); };
var BulkDisableEnableButton = function (_a) {
    var settings = _a.settings, category = _a.category, bulkSelectHandler = _a.bulkSelectHandler;
    var notAllEnabled = settings.some(function (setting) { return !setting.on; });
    return (react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return bulkSelectHandler(category); }, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, notAllEnabled ? "Enable all" : "Disable all"));
};
var NotificationCard = function (_a) {
    var heading = _a.heading, subtext = _a.subtext, toggleHandler = _a.toggleHandler, selectHandler = _a.selectHandler, inputHandler = _a.inputHandler, bulkSelectHandler = _a.bulkSelectHandler, category = _a.category, settings = _a.settings, iconElement = _a.iconElement, iconStyle = _a.iconStyle;
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.v2NotificationCard },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "spaceBetween" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", align: "center" },
                    react_1.default.createElement("div", { className: iconStyle }, iconElement),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, heading),
                        react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" }, subtext))),
                react_1.default.createElement(BulkDisableEnableButton, { settings: settings, category: category, bulkSelectHandler: bulkSelectHandler })),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", justify: "center" }, settings.map(function (setting, i) {
                if (setting.type === "toggle") {
                    return (react_1.default.createElement(kaleidoscope_1.Stack, { key: setting.setting, className: styles.settingsRow({ hasDivider: i !== settings.length - 1 }), direction: "horizontal", align: "center", justify: "spaceBetween" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "start", gap: "xs" },
                                react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" }, setting.label),
                                setting.tooltip && (react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, size: kaleidoscope_1.ButtonSize.XSmall, icon: react_1.default.createElement(icons_1.HelpLite, null), type: kaleidoscope_1.ButtonType.Secondary, tooltip: { content: setting.tooltip, size: kaleidoscope_1.TooltipSize.Large } })))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "end" }, setting.disabled ? (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, content: "This notification is always on and cannot be turned off", show: setting.on
                                    ? undefined
                                    :
                                        false },
                                react_1.default.createElement(kaleidoscope_1.Label, { secondary: true, size: "s" }, setting.on ? "Enabled" : "Disabled"))) : (react_1.default.createElement("div", null,
                                react_1.default.createElement(kaleidoscope_1.Toggle, { labelHidden: true, disabled: setting.disabled, key: setting.setting, label: setting.label, value: setting.on, onChange: function () { return toggleHandler(category, setting.setting); } })))))));
                }
                return (react_1.default.createElement(kaleidoscope_1.Stack, { key: setting.setting, className: styles.settingsRow({ hasDivider: i !== settings.length - 1 }), direction: "horizontal", align: "center", justify: "spaceBetween" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Text, { element: "div", size: "s" }, setting.label)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "end", gap: "s" },
                            "alertOn" in setting && (react_1.default.createElement("div", { className: styles.dropDownStyle },
                                react_1.default.createElement(kaleidoscope_1.Select, { size: "m", label: "Granular Alert On Settings", placeholder: "1", labelHidden: true, autoStack: true, value: setting.alertOn, onChange: function (event) { return selectHandler(category, setting.setting, event); } },
                                    selectOptions.map(function (option) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { keepOpenOnSelect: option.value === "custom", key: option.value, value: option.value }, option.label)); }),
                                    setting.alertOn === "custom" && (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.customNumberSelect, align: "center", direction: "horizontal" },
                                        react_1.default.createElement(NumberInput_1.default, { labelHidden: true, showStepper: true, min: 1, endElement: react_1.default.createElement(CustomNumberEndElement, null), variant: kaleidoscope_1.TextInputVariant.Bordered, size: kaleidoscope_1.TextInputSize.Small, label: setting.label, value: setting.customNumber, onChange: function (value) { return inputHandler(category, setting.setting, value); } })))))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(kaleidoscope_1.Toggle, { disabled: setting.disabled, key: setting.setting, label: setting.label, labelHidden: true, value: setting.on, onChange: function () { return toggleHandler(category, setting.setting); } }))))));
            })))));
};
var V2NotificationSettings = function () {
    var _a = (0, UseNotificationsSettings_1.UseNotificationsSettings)(), settings = _a.settings, updater = _a.updater;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.wrapper, align: "center" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.content, gap: "l" },
            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.framedNotificationIcon, align: "center", justify: "center" },
                    react_1.default.createElement(icons_1.Notifications, null)),
                react_1.default.createElement(kaleidoscope_1.Label, { size: "l" }, "Notifications"),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                    "Choose which notifications you will receive for your pages. For more information visit the",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/155-notifications" }, " notifications help docs."))),
            settings ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Settings, { settings: settings, updater: updater }))) : (react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true })))));
};
exports.V2NotificationSettings = V2NotificationSettings;
var Settings = function (_a) {
    var _b, _c;
    var settings = _a.settings, updater = _a.updater;
    var isFirstRender = (0, UseIsFirstRender_1.useIsFirstRender)();
    var _d = __read((0, react_1.useState)(function () { return settings; }), 2), settingsState = _d[0], setSettingsState = _d[1];
    var handleToggle = function (category, selected) {
        setSettingsState(function (settings) {
            var _a;
            return (__assign(__assign({}, settings), (_a = {}, _a[category] = settings[category].reduce(function (acc, setting) {
                if (setting.setting !== selected)
                    return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                if (setting.type === "toggle") {
                    return __spreadArray(__spreadArray([], __read(acc), false), [
                        __assign(__assign({}, setting), { on: !setting.on }),
                    ], false);
                }
                if (setting.on) {
                    return __spreadArray(__spreadArray([], __read(acc), false), [
                        {
                            setting: setting.setting,
                            on: !setting.on,
                            label: setting.label,
                            type: "granular",
                        },
                    ], false);
                }
                return __spreadArray(__spreadArray([], __read(acc), false), [
                    __assign(__assign({}, setting), { on: !setting.on, alertOn: "first" }),
                ], false);
            }, []), _a)));
        });
    };
    var handleSelect = function (category, selectedSetting, selection) {
        setSettingsState(function (settings) {
            var _a;
            return (__assign(__assign({}, settings), (_a = {}, _a[category] = settings[category].reduce(function (acc, setting) {
                if (setting.setting !== selectedSetting)
                    return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                if (selection === "first")
                    return __spreadArray(__spreadArray([], __read(acc), false), [__assign(__assign({}, setting), { alertOn: "first" })], false);
                if (selection === "every")
                    return __spreadArray(__spreadArray([], __read(acc), false), [__assign(__assign({}, setting), { alertOn: "every" })], false);
                if ("alertOn" in setting) {
                    if (setting.alertOn === "custom")
                        return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                    return __spreadArray(__spreadArray([], __read(acc), false), [__assign(__assign({}, setting), { alertOn: "custom", customNumber: 1 })], false);
                }
            }, []), _a)));
        });
    };
    var handleNumberInput = function (category, selectedSetting, value) {
        setSettingsState(function (settings) {
            var _a;
            return (__assign(__assign({}, settings), (_a = {}, _a[category] = settings[category].reduce(function (acc, setting) {
                if (setting.setting !== selectedSetting)
                    return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                return __spreadArray(__spreadArray([], __read(acc), false), [__assign(__assign({}, setting), { customNumber: value })], false);
            }, []), _a)));
        });
    };
    var bulkSelectHandler = function (category) {
        setSettingsState(function (settings) {
            var _a;
            var notAllOn = settings[category].some(function (setting) { return !setting.on; });
            return __assign(__assign({}, settings), (_a = {}, _a[category] = settings[category].reduce(function (acc, setting) {
                if (setting.type === "toggle") {
                    if (setting.disabled)
                        return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                    return __spreadArray(__spreadArray([], __read(acc), false), [
                        __assign(__assign({}, setting), { on: notAllOn ? true : false }),
                    ], false);
                }
                if (notAllOn) {
                    if (setting.on)
                        return __spreadArray(__spreadArray([], __read(acc), false), [setting], false);
                    return __spreadArray(__spreadArray([], __read(acc), false), [
                        __assign(__assign({}, setting), { on: !setting.on, alertOn: "first" }),
                    ], false);
                }
                return __spreadArray(__spreadArray([], __read(acc), false), [
                    {
                        setting: setting.setting,
                        on: !setting.on,
                        label: setting.label,
                        type: "granular",
                    },
                ], false);
            }, []), _a));
        });
    };
    (0, react_1.useEffect)(function () {
        if (isFirstRender)
            return;
        try {
            updater(settingsState);
        }
        catch (e) {
            console.error("----update error", e);
        }
    }, [settingsState]);
    var commonProps = {
        toggleHandler: handleToggle,
        selectHandler: handleSelect,
        inputHandler: handleNumberInput,
        bulkSelectHandler: bulkSelectHandler,
    };
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", align: "center", paddingBottom: "xl" },
        react_1.default.createElement(NotificationCard, __assign({ heading: "Engagement events", subtext: "Get notified when your pages are engaged with", category: "engagement", settings: settingsState.engagement, iconElement: react_1.default.createElement(icons_1.Page, { className: styles.blueSvg }), iconStyle: styles.engagementIconStyle }, commonProps)),
        react_1.default.createElement(NotificationCard, __assign({ heading: "Viewership events", subtext: "Who is viewing your pages", category: "viewership", settings: settingsState.viewership, iconStyle: styles.viewershipIconStyle, iconElement: react_1.default.createElement(icons_1.Preview, { style: (0, dynamic_1.assignInlineVars)((_b = {},
                    _b[kaleidoscope_1.iconVars.color] = tokens_1.palette.purple600,
                    _b)) }) }, commonProps)),
        react_1.default.createElement(NotificationCard, __assign({ heading: "Transaction events", subtext: "Pricing, e-sign and payment interactions", category: "transaction", settings: settingsState.transaction, iconElement: react_1.default.createElement(icons_1.Value, { style: (0, dynamic_1.assignInlineVars)((_c = {},
                    _c[kaleidoscope_1.iconVars.accentColor] = tokens_1.palette.yellow400,
                    _c[kaleidoscope_1.iconVars.color] = tokens_1.palette.yellow400,
                    _c)) }), iconStyle: styles.transactionIconStyle }, commonProps))));
};
